/** 一条月账的现金+存款核对:期初 + 净收付 = 期末? */
type Data = Record<string, unknown>;
const object = (v: unknown): Data | null => v != null && typeof v === 'object' && !Array.isArray(v) ? v as Data : null;
const integer = (v: unknown): v is number => typeof v === 'number' && Number.isSafeInteger(v);
const uint = (v: unknown): v is number => integer(v) && v >= 0 && v <= 0xffffffff;
const when = (d: number) => `第 ${Math.floor(d / 360) + 1} 年 ${Math.floor(d % 360 / 30) + 1} 月 ${d % 30 + 1} 日（游戏日 ${d}）`;
/** 安全整数分直接按十进制位拆元；不经浮点除100或toFixed。 */
const cents = (v: number) => {
  const digits = String(Math.abs(v)).padStart(3, '0');
  return `${v < 0 ? '-' : ''}${digits.slice(0, -2)}.${digits.slice(-2)} 元`;
};
const UNIT_FIELDS = ['period.balance.cash', 'period.balance.deposit', 'opening.balance.cash', 'opening.balance.deposit', 'period.totalIn', 'period.totalOut', 'flows.amount'];
export function liquidBridgeText(record: unknown, owner: unknown, metadata: unknown): string[] {
  const title = '现金与存款核对';
  const unavailable = (reason: string) => [title, `核对不了：${reason}。`];
  const r = object(record), who = object(owner), meta = object(metadata);
  if (!r || !who || who.kind !== 'person' || !uint(who.id) || r.kind !== 'person' || r.source !== 'resident_period' || !uint(r.entityId) || r.entityId !== who.id)
    return unavailable('不是这个人的月账');
  if (!meta || meta.version !== 1 || meta.moneyUnit !== 'cent') return unavailable('金额单位未记录');
  if (Object.hasOwn(meta, 'units')) {
    const units = object(meta.units);
    if (!units || UNIT_FIELDS.some(key => Object.hasOwn(units, key) && units[key] !== 'cent')) return unavailable('金额单位对不上');
  }
  const d = object(r.data), p = object(d?.period), o = object(d?.opening);
  if (d?.completeFlows !== true || d.flowWindow !== 'book_month') return unavailable('这个月的收付记录不全');
  if (o?.kind !== 'previous_closing') return unavailable('没有上月结账余额');
  if (!p || !uint(p.day) || !uint(r.day) || !uint(o.day) || p.day !== r.day || p.day - o.day !== 30) return unavailable('日子对不上');
  const before = object(o.balance), after = object(p.balance);
  const a = before?.cash, b = before?.deposit, c = after?.cash, e = after?.deposit, income = p.totalIn, spending = p.totalOut;
  if (!integer(a) || !integer(b) || !integer(c) || !integer(e) || !integer(income) || !integer(spending)) return unavailable('金额缺失');
  const opening = a + b;
  if (!Number.isSafeInteger(opening)) return unavailable('金额太大');
  const closing = c + e;
  if (!Number.isSafeInteger(closing)) return unavailable('金额太大');
  const net = income - spending;
  if (!Number.isSafeInteger(net)) return unavailable('金额太大');
  const expected = opening + net;
  if (!Number.isSafeInteger(expected)) return unavailable('金额太大');
  const difference = closing - expected;
  if (!Number.isSafeInteger(difference)) return unavailable('金额太大');
  return [title, `${when(o.day)} → ${when(p.day)}`,
    `流入 ${cents(income)} · 流出 ${cents(spending)}`,
    `期初现金及存款 ${cents(opening)} + 净收付 ${cents(net)} = 应有期末 ${cents(expected)}`,
    `实际期末 ${cents(closing)} · 差 ${cents(difference)}`];
}
